import React from "react";
import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";

import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-gradient-to-r from-gray-50 via-white to-gray-100 text-gray-700 pt-12 pb-6 mt-10 border-t">
      <div className="max-w-7xl mx-auto px-6">
        {/* GRID */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10">
          {/* BRAND */}
          <div>
            <h2 className="text-2xl font-bold text-red-600 mb-3">
              MedrphaLabs
            </h2>

            <p className="text-sm leading-relaxed text-gray-600">
              We bring medicines, lab tests, wellness, and healthcare services
              to your doorstep.
            </p>
          </div>

          {/* QUICK LINKS */}
          <div>
            <h3 className="text-lg font-semibold text-red-600 mb-3">
              Quick Links
            </h3>

            <ul className="space-y-2 text-sm">
              <li>
                <Link
                  to="/partner-with-us"
                  className="text-gray-600"
                >
                  Partner With Us
                </Link>
              </li>

              <li>
                <Link
                  to="/about"
                  className="text-gray-600"
                >
                  About Us
                </Link>
              </li>

              <li>
                <Link
                  to="/services"
                  className="text-gray-600"
                >
                  Services
                </Link>
              </li>

              <li>
                <Link
                  to="/faq"
                  className="text-gray-600"
                >
                  FAQ
                </Link>
              </li>

              <li>
                <Link
                  to="/privacy-policy"
                  className="text-gray-600"
                >
                  Privacy Policy
                </Link>
              </li>

              <li>
                <Link
                  to="/terms-conditions"
                  className="text-gray-600"
                >
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>

          {/* SERVICES */}
          <div>
            <h3 className="text-lg font-semibold text-red-600 mb-3">
              Our Services
            </h3>

            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/medicine" className="text-gray-600">
                  Medicine Delivery
                </Link>
              </li>

              <li>
                <Link to="/labtest" className="text-gray-600">
                  Lab Tests
                </Link>
              </li>

              <li>
                <Link to="/care-plan" className="text-gray-600">
                  Care Plans
                </Link>
              </li>

              <li>
                <Link to="/wellness" className="text-gray-600">
                  Wellness
                </Link>
              </li>

              <li>
                <Link to="/profile" className="text-gray-600">
                  Doctor Consultation
                </Link>
              </li>
            </ul>
          </div>

          {/* CONTACT */}
          <div>
            <h3 className="text-lg font-semibold text-red-600 mb-3">
              Contact Us
            </h3>

            <div className="space-y-3 text-sm text-gray-600">
              <p className="flex items-start gap-2">
                <FaMapMarkerAlt className="text-red-500 mt-1" />
                <span>MEDRPHALABS Noida Sec-6 India</span>
              </p>

              <p className="flex items-center gap-2">
                <FaPhone className="text-red-500" />
                <a href="tel:+918178399885">
                  +91-81783 99885
                </a>
              </p>

              <p className="flex items-center gap-2">
                <FaEnvelope className="text-red-500" />
                <a href="mailto:info@medrpha.com">
                  info@medrpha.com
                </a>
              </p>

              <p className="flex items-center gap-2">
                <FaPhone className="text-red-500" />
                <a href="tel:01203200262">
                  Toll Free: 0120-3200262
                </a>
              </p>
            </div>

            {/* SOCIAL MEDIA */}
            <div className="flex gap-4 mt-5">
              <a
                href="https://www.facebook.com/MedrphaLabTest"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-white shadow-md text-gray-700 cursor-pointer"
              >
                <FaFacebook size={18} />
              </a>

              <a
                href="https://www.instagram.com/medrphalab"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-white shadow-md text-gray-700 cursor-pointer"
              >
                <FaInstagram size={18} />
              </a>

              <a
                href="https://www.youtube.com/@MedrphaLabTest"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-white shadow-md text-gray-700 cursor-pointer"
              >
                <FaYoutube size={18} />
              </a>
            </div>
          </div>
        </div>

        {/* BOTTOM */}
        <div className="text-center mt-10 border-t pt-4 text-sm text-gray-500">
          © {new Date().getFullYear()} MedrphaLabs. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
}